import { getPreloaderFnContext } from '@confluence/query-preloader-tools/entry-points/preloaderFnContext';
import { ConfluenceEdition } from '@confluence/session-data/entry-points/SiteInformationQuery';
import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError';
import { queryAgg } from '@confluence/query-preloader-tools/entry-points/graphql';

import { ConfluenceFreePoolTargetExperimentQuery } from './ConfluenceFreePoolTargetExperimentQuery';

export function preloadUpgradeModalQuery() {
	const { cloudId, edition, isLoggedIn } = getPreloaderFnContext();
	const queries: Promise<any>[] = [];

	// Add preloading on SSR only if user is on Confluence Free
	if (isLoggedIn && cloudId && edition === ConfluenceEdition.FREE) {
		queries.push(
			queryAgg({
				query: ConfluenceFreePoolTargetExperimentQuery,
				variables: {
					cloudId,
					productKey: 'confluence.ondemand',
				},
			}),
		);
	}

	return waitForAllReturnWhenError(queries);
}
